import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/utils.js';
export function Tabs({ items, value, onValueChange, className, 'aria-label': ariaLabel, }) {
    const refs = React.useRef([]);
    // Roving arrow-key navigation is required for role=tablist; without it the
    // tabs are a keyboard dead end.
    const onKeyDown = (e, index) => {
        const delta = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!delta)
            return;
        e.preventDefault();
        const enabled = items.map((it, i) => (it.disabled ? -1 : i)).filter((i) => i >= 0);
        const at = enabled.indexOf(index);
        const next = enabled[(at + delta + enabled.length) % enabled.length];
        if (next === undefined)
            return;
        refs.current[next]?.focus();
        onValueChange(items[next].value);
    };
    return (_jsx("div", { role: "tablist", "aria-label": ariaLabel, className: cn('flex items-center gap-1 border-b border-border', className), children: items.map((item, i) => {
            const active = item.value === value;
            return (_jsxs("button", { ref: (el) => { refs.current[i] = el; }, role: "tab", type: "button", "aria-selected": active, tabIndex: active ? 0 : -1, disabled: item.disabled, onClick: () => onValueChange(item.value), onKeyDown: (e) => onKeyDown(e, i), className: cn('-mb-px flex items-center gap-2 border-b-2 px-3 py-2 text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50', active
                    ? 'border-accent-solid text-foreground'
                    : 'border-transparent text-muted-foreground hover:border-border-strong hover:text-foreground'), children: [item.label, item.badge !== undefined && (_jsx("span", { className: "rounded-full bg-muted px-1.5 font-mono text-2xs text-muted-foreground", children: item.badge }))] }, item.value));
        }) }));
}
